import {createContext} from "react";

export const ViewLoaderContext = createContext<any>({
  isViewLoaderVisible: false,
  setIsViewLoaderVisible: () => {}
});
